import { render } from "./payment-methods.vue?vue&type=template&id=670cd470"
import script from "./payment-methods.vue?vue&type=script&lang=js"
export * from "./payment-methods.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__